import { useEffect, useState } from "react"

import { collection, getDocs } from "firebase/firestore"
import { SelectItem } from "@mantine/core"

import { firebase } from "../../../services/firebase/firebase"

export default () => {
    const [data, setData] = useState<SelectItem[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getDocs(collection(firebase.firestore, "organisations"))
            .then(snapshot => snapshot.docs.map(doc => ({ label: doc.data().name, value: doc.id })))
            .then(setData)
            .catch(console.error)
            .finally(() => setLoading(false))
    }, [])

    return { data, loading }
}
